// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {get_img_url} from './utils';
import styles from './bounty_program_scope.module.less';

export interface i_bounty_scope_item {
  title: string;
  image_src?: string;
  image_alt?: string;
}

export interface i_bounty_program_scope_props {
  title?: string;
  description?: string;
  items?: i_bounty_scope_item[];
  footnote?: string;
}

export const Bounty_program_scope = ({
  title,
  description,
  items=[],
  footnote,
}: i_bounty_program_scope_props)=>{
  return <section className={styles.bounty_program_scope}>
    <div className={styles.bounty_program_scope__inner}>
      <div className={styles.bounty_program_scope__heading}>
        {title&&<h3 className={styles.bounty_program_scope__title}>
          {title}
        </h3>}
        {description&&<p
          className={styles.bounty_program_scope__description}>
          {description}
        </p>}
      </div>
      {!!items.length&&<ul className={styles.bounty_program_scope__list}>
        {items.map((item, index)=><li
          key={`${item.title}-${index}`}
          className={styles.bounty_program_scope__item}>
          {item.image_src&&<img
            className={styles.bounty_program_scope__icon}
            src={get_img_url(item.image_src)}
            alt={item.image_alt||''}
            aria-hidden={!item.image_alt}
          />}
          <span className={styles.bounty_program_scope__item_title}>
            {item.title}
          </span>
        </li>)}
      </ul>}
      {footnote&&<p className={styles.bounty_program_scope__footnote}>
        {footnote}
      </p>}
    </div>
  </section>;
};

interface i_bounty_program_scope_editor_props {
  value: i_bounty_program_scope_props;
  on_change: (value: i_bounty_program_scope_props)=>void;
  on_cancel?: ()=>void;
}

export const Bounty_program_scope_editor = (
  props: i_bounty_program_scope_editor_props
)=>{
  const [state, set_state] = useState<i_bounty_program_scope_props>({
    ...props.value,
    items: props.value?.items||[],
  });

  const items = state.items||[];

  const update_item = (index: number, item: i_bounty_scope_item)=>{
    const next_items = [...items];
    next_items[index] = item;
    set_state({...state, items: next_items});
  };

  const delete_item = (index: number)=>{
    set_state({
      ...state,
      items: items||[].filter((_, i)=>i!=index),
    });
  };

  return <Editor<i_bounty_program_scope_props>
    value={state}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'textarea'},
      {key: 'footnote', label: 'Footnote', type: 'textarea'},
    ]}
    on_change={set_state}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
    <Fragment>
      {(items||[]).map((item, index)=><div key={index}>
        <Editor<i_bounty_scope_item>
          title={item.title||`Item ${index+1}`}
          value={item}
          editors={[
            {key: 'title', label: 'Item title', type: 'text'},
            {key: 'image_src', label: 'Icon', type: 'text'},
            {key: 'image_alt', label: 'Icon alt', type: 'text'},
          ]}
          on_change={(value: i_bounty_scope_item)=>
            update_item(index, value)}
        />
        <Button
          caption="Delete item"
          size="xs"
          color="secondary"
          on_click={()=>delete_item(index)}
        />
        <hr/>
      </div>)}
      <Button
        caption="Add item"
        size="xs"
        on_click={()=>set_state({
          ...state,
          items: [...items,
            {
              title: '',
              image_src: '',
              image_alt: '',
            },
          ],
        })}
      />
    </Fragment>
  </Editor>;
};
